export default {
  manage: {
    manage: 'Manage',
    empty: 'No Data'
  },
  login: {
    stateRequired: 'CAPTCHA is required',
    state: 'CAPTCHA',
    username: 'Username',
    password: 'Password',
    remember: 'Remember Me',
    logIn: 'Log In',
    forget: 'Forget Password',
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required',
    solutionRequired: 'Solution is required',
    noAccount: 'No account set information has been obtained, please contact the administrator!',
    styleError: 'Failed to get login style information!',
    fedLogOut: 'Login has expired, please log in again!',
    error: 'Request failed! Please contact your administrator for more information.',
    expired: 'Password Expired',
    return: 'Return',
    goTo: 'Go To',
    gettingSolutions: 'We are getting solutions,please wait...',
    noSolution: 'Missing solution'
  },
  dashboard: {
    flow: 'Workflow',
    fast: 'Fast',
    noData: 'No Data'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  buttons: {
    resume: 'Resume',
    manage: 'Manage',
    customButton: 'Custom Button',
    relevantReport: 'Relevant Report',
    relatedReport: 'Related Report',
    sendEmail: 'Send Email',
    lastThreeMonths: 'Last Three Months',
    lastMonth: 'Last Month',
    lastWeek: 'Last Week',
    all: 'All',
    copyCreate: 'Copy&Create',
    notify: 'Notify',
    total: 'Total ',
    choosed: ' ',
    num: '',
    batch: 'Batch',
    unreaded: 'Unread',
    test: 'Test',
    determine: 'Determine',
    urge: 'Urge',
    startUnfinished: 'Unfinished',
    moreNote: 'More',
    lock: 'Lock',
    unlock: 'Unlock',
    showAll: 'Show All',
    start: 'Initiate',
    unprocessed: 'Unprocessed',
    upcoming: 'Upcoming',
    done: 'Done',
    search: 'Search For',
    advance: 'Advanced',
    common: 'Common',
    check: 'Check',
    schedule: 'Schedule',
    refresh: 'Refresh',
    create: 'New',
    edit: 'Edit',
    delete: 'Delete',
    batchDelete: 'Batch Deletion',
    handle: 'Handle',
    rollBack: 'Roll Back',
    reDo: 'Redo',
    history: 'History',
    more: 'More',
    importData: 'Import Data',
    exportData: 'Export Data',
    checkExportData: 'Check Export Data',
    noImgdownloadData: 'No Imgage Export Data',
    import: 'Import',
    export: 'Export',
    downloadTemplate: 'Download Template',
    print: 'Print',
    excel: 'Excel',
    pdf: 'PDF',
    cancel: 'Cancel',
    confirm: 'Confirm',
    read: 'Read',
    unread: 'Unread',
    setting: 'Setting',
    logOut: 'Log Out',
    about: 'About',
    save: 'Save',
    temporary: 'Temporary',
    submit: 'Submit',
    launch: 'Launch',
    saveAndCreate: 'Save And Create',
    saveAndClose: 'Save And Close',
    close: 'Shut Down',
    clear: 'Clear',
    home: 'Home',
    workflowManage: 'Workflow Manage',
    reviewReport: 'Review',
    cancelReport: 'Cancel Review',
    voidReport: 'Void'
  },
  table: {
    rid: 'RID',
    type: 'Type',
    name: 'Name',
    loadMore: 'Load More',
    noData: 'No Data',
    dept_name: 'Dept Name',
    user_name: 'User Name',
    fillDate: 'Report Time',
    lastModUser: 'Last Modified User',
    lastModDate: 'Last Modified',
    toolBar: 'Operating',
    SN: 'SN',
    all: 'All'
  },
  dialogTitle: {
    messages: 'Messages',
    warnings: 'Warnings',
    start: 'Start',
    appSetting: 'App Setting',
    chooseData: 'Choose Data',
    rollBack: 'Roll Back',
    submit: 'Submit'
  },
  status: {
    success: 'Success',
    warning: 'Warning',
    prompt: 'Prompt',
    error: 'Error',
    noMsg: 'No Data',
    noWarning: 'No Data',
    noData: 'No Data',
    noSummary: 'No Summary'
  },
  schedule: {
    flowChart: 'Flow Chart',
    dealDate: 'Deal Date',
    opinion: 'Opinion',
    note: 'Note',
    task: 'Task',
    handler: 'Handler',
    description: 'Desc.'
  },
  placeholder: {
    search: 'Enter search content'
  },
  alert: {
    notFound: 'Content not found',
    saveSuccess: 'Save Success',
    isRead: 'Mark as read?',
    readSuccess: 'Read Success',
    receiveWarning: 'You have a new warning',
    receiveNotification: 'You have a new message',
    receiveUpcoming: 'You have a new to-do',
    fedLogOut: 'Your account is logged in on another device. Please log in again',
    deleteMsg: 'Do you want to delete this message?',
    delete: 'Do you want to delete this record?',
    workflow: 'Do you want to cancel?',
    deleteSuccess: 'Delete Success',
    batchDeleteBefore: 'Do you want to delete these ',
    batchDeleteAfter: ' records?',
    lock: 'Lock Success',
    unlock: 'Unlock Success',
    importSuccess: 'Import Finished',
    notFoundInfo: 'No relevant information was found',
    notBoundView: 'This message is not bound to view the form',
    notBoundAssociated: 'This message is not bound to the associated form',
    isLogOut: 'Do you want to log out?',
    cancelReviewSuccess: 'Cancel review report success!',
    cancelReviewFailed: 'Cancel review report failed!',
    reviewSuccess: 'Review report success!',
    reviewFailed: 'Review report failed!',
    voidSuccess: 'Void report success!',
    voidFailed: 'Void report failed!',
    voidWarning: 'After voiding, the report cannot be restored. Do you want to continue?',
    cloase: 'Closing report.Continue?'
  },
  workflow: {
    myProcess: 'myProcess',
    myStart: 'myStart',
    allWorkflow: 'All',
    notAllow: 'The current process does not meet the conditions and cannot be submitted!',
    noMore: 'No more',
    loading: 'Loading...',
    noProcess: 'There is no process to initiate',
    errprPrompt: 'Process error prompt',
    submitFail: 'Since there are no steps that meet the conditions, the submission fails!',
    batchApproval: 'Batch Approval',
    dealType: 'Deal Type',
    all: 'All',
    urge: 'Urge',
    prompt: 'Prompt',
    isUrge: 'Do you want to urge?',
    urgeSuccess: 'Urge Success',
    mine: 'My sponsor',
    read: 'Read',
    unprocessed: 'Commits not processed',
    message: 'Messages',
    doing: 'Ongoing process',
    end: 'Ended process',
    delete: 'Deletable process',
    todo: 'To-do items',
    temporary: 'Temporary items',
    unread: 'Things to read',
    done: 'Things to do',
    workflow: 'Process Management',
    oneNext: 'Please manually specify the next step executor',
    moreNext: 'There are multiple nodes that satisfy the flow of the process, please select the next flow of approval',
    hasWorkflow: 'There are multiple initiable processes in the current template',
    noTemplate: 'The initiation step is not bound to the form, do you submit the current process directly?',
    submitTitle: 'Process Direction',
    rollBackOpinion: 'Opinion',
    rollBackType: 'Type',
    chooseRollBackOpinion: 'Please choose an opinion',
    enterRollBackOpinion: 'Please enter opinion',
    isBack: 'Do you want to roll back?',
    backward: 'Backward',
    backhead: 'Back-head',
    backappoint: 'Back-appoint',
    backSuccess: 'Roll Back Success',
    submitSuccess: 'Submit Success',
    temporarySuccess: 'Temporary Success',
    SubmitOpinion: 'Opinion',
    SubmitType: 'Type',
    chooseSubmitOpinion: 'Please choose an opinion',
    enterSubmitOpinion: 'Please enter opinion',
    isSubmit: 'Do you want to submit?',
    failSubmit: 'Fail Submit',
    temporarySubmit: 'Temporary Submit',
    isRedo: 'Do you want to redo?',
    redoSuccess: 'Redo Success',
    noneSchedule: 'There are no commit tasks in the current process'
  },
  setting: {
    language: 'Language',
    big3: 'WidenⅢ',
    big2: 'WidenⅡ',
    big1: 'WidenⅠ',
    small3: 'CompactⅢ',
    small2: 'CompactⅡ',
    small1: 'CompactⅠ',
    normal: 'Normal',
    leftSeptum: 'Left septum',
    emailPass: 'E-mail Password',
    email: 'E-mail Address',
    mail: 'Mail',
    avatar: 'Personal',
    nickname: 'Nickname',
    password: 'Password',
    avatarMaxSize: 'Maximum can not exceed 2MB',
    oldPass: 'Old Password',
    newPass: 'New Password',
    checkPass: 'Confirm Password',
    nicknameSuccess: 'Nickname modify succeess ',
    passwordSuccess: 'Password modify succeess',
    UI: 'System Interface'
  },
  workflowTable: {
    name: 'Process Name',
    step: 'Step Name',
    note: 'Summary description',
    creator: 'Submitter',
    createDate: 'Submit Date',
    handler: 'Submitter',
    dealDate: 'Submit Date',
    startDate: 'Start Date'
  },
  validation: {
    passwordDiff: 'The two passwords differ!',
    nickname: 'Nickname is required',
    email: 'E-mail address is required',
    errorMail: 'Please enter the correct E-mail address',
    emailPass: 'E-mail password is required'
  },
  theme: {
    default: 'Default',
    ywcq: 'Blue Sky',
    qqzj: 'Green Spring',
    fyhl: 'Red Maple'
  },
  mail: {
    selectUser: 'Select User',
    user: 'User',
    dept: 'Department',
    title: 'E-mail',
    address: 'Addressee',
    copy: 'Cc',
    subject: 'Subject',
    body: 'Text',
    attach: 'Attach',
    send: 'Send',
    cancel: 'Cancel',
    success: 'Send Success',
    isCancel: 'Cancel Send?'
  },
  report: {
    noRecord: 'No record found!',
    delete: 'Delete',
    modify: 'Modify',
    download: 'Download',
    preview: 'Preview',
    upload: 'Upload',
    integer: 'Please enter a positive integer',
    extendRow: 'Please enter the number of extended rows',
    extendColumn: 'Please enter the number of extended columns',
    rowError: 'The template file is wrong! Extended row failed',
    insertRowError: 'The inserted row is beyond the effective editing range!',
    insertColumnError: 'The inserted column exceeds the effective use range! It is recommended to use the big data mode to expand the effective rows.',
    deleteRowError: 'The template file is wrong! Failed to delete row',
    lessThan2Row: 'The extended table area must not be less than two rows!',
    lessThan2Column: 'The expanded table area must not be less than two columns!',
    cannotDelete: 'This row cannot be deleted!',
    mainTableNotClear: 'The main table does not support clearing all data',
    dataSheet: 'Data Sheet',
    alias: 'Alias',
    field: 'Field',
    notInTemp: 'Does not exist in the template!',
    notSupportAutomatic: 'The browser you use does not support automatic statistics!',
    processError: 'Process information initialization failed!',
    noEditRights: 'You do not have editing rights to this document!',
    advancedPermissionError: 'Failed to get the advanced permission!',
    templateError: 'Failed to initialize template attributes!',
    nothingDesigned: 'This template has nothing designed!',
    emptyTemp: 'The template file is empty!',
    tempFileError: 'Failed to get template file!',
    printAreaError: 'Failed to process print area!',
    queryFormulaError: 'Query formula initialization failed!',
    linkError: 'Hyperlink initialization failed!',
    paramError: 'Parameter information is wrong!',
    triggerCustom: 'Trigger a custom button',
    backFormulaExecuteError: 'Failed to execute write-back formula! Step ID ',
    actionError: 'Action execution failed! Step ID ',
    undefinedAction: 'Undefined action event type!',
    mailParamError: 'Error in collating mail parameter data!',
    mailSettingError: 'The mail sending setting does not exist or the timing is incorrect!',
    saveField: 'Save failed! ',
    reportEmpty: 'The content of the receipt is empty!',
    documentConentError: 'Failed to open the content of the document! ',
    crossTableFillError: 'Do not support the rapid filling of the cross table!',
    stateError: 'Abnormal document state switching!',
    uploadTryLater: 'Uploading file, please try again later!',
    editLockError: 'Edit lock acquisition failed! Please reopen to modify!',
    uploading: 'Uploading image attachment',
    completed: 'Completed',
    uploaded: 'The selected content has been uploaded!',
    uploadFail: 'File upload failed! ',
    duplicate: 'is duplicate!',
    duplicateValue: 'is duplicate!，value',
    crosstab: 'Crosstab',
    dataFormatError: 'The data content does not meet the format requirements!',
    isRequired: 'Is required!',
    exceedLimit: 'The number of characters exceeds the limit!',
    digitsLimit: 'The number of digits exceeds the limit!',
    mustNumber: 'The value must be a number!',
    mustDate: 'The value must be a date!',
    legalDate: 'The value must be a legal date!',
    contentLimit: 'The content exceeds the quantity limit!',
    legalID: 'Not a legal ID card!',
    legalEmail: 'Not a valid e-mail!',
    mobileVaild: 'Not a valid mobile number!',
    openReportFailed: 'Failed to open the report! ',
    editState: 'The record is in edit state!',
    editLockError1: 'Re-modification may produce errors!',
    unkonwn: 'Unkonwn Error!',
    cascadError: 'Cascader failed to open!',
    automaticNmberError: ' Failed to get the automatic number! ',
    dropDownError: ' Failed to get the drop-down list! ',
    listError: 'Failed to open list!',
    noListAvailable: 'No list available!',
    corsstabDimension: 'The content filled by crosstab association must be in the same dimension!',
    dataSheetType: 'Data sheet type',
    notExist: 'Not exist!',
    otherTable: 'No other extension table values are supported yet!',
    noSignature: 'No signature found!',
    defaultSignature: 'Please set the default signature first!',
    waiting: 'Please wait while it is being executed.',
    noDataObtained: 'No data obtained!',
    queryFail: 'The query formula failed to execute!',
    queryTimingError: 'The execution timing of the query formula is wrong!',
    styleTimingError: 'The timing of dynamic style execution is wrong!',
    styleError: 'Dynamic style execution failed!',
    formatError: 'Conditional format initialization failed!',
    alasqlError: 'AlaSQL data table creation failed!',
    fieldFailLegal: 'The value of the expansion table of this report failed! Please check if the reference is legal.',
    illegalOperation: 'Illegal operation, blocked',
    addRow: 'Add Row',
    deleteRow: 'Delete Row',
    customRows: 'Custom Rows',
    addColumn: 'Add Column',
    deleteColumn: 'Delete Column',
    customColumns: 'Custom Columns',
    isDiscard: 'Are you sure you want to discard changes',
    printArea: 'Please set the print area first!',
    noInfo: 'No relevant information found',
    clearFill: 'Clear Fill',
    delimiter: 'Delimiter',
    row: ' rows',
    column: ' columns',
    uploadSelect: 'Uploading selected content',
    inputRemark: 'Please input tag',
    temporarySuccess: 'Save temporary successed!',
    illegalTemporary: 'Failed to save temporary record!'
  },
  preview: {
    import: 'Import',
    chooseFile: 'Choose File',
    errorFile: 'Eorror File',
    timeCost: 'Time Cost',
    failedCount: 'Failed Count',
    importCount: 'Import Count',
    importType: 'Import Type',
    importMethod: 'Import Method',
    links: 'Links',
    executionSucceed: 'Execution Success!',
    executionFailed: 'Execution Failed!',
    isExecut: 'Is Execut?',
    downloadFailed: 'File download failed!',
    oneFile: 'Only one file can be selected at a time!',
    fileLimit: 'The upload file size exceeds the limit!',
    partSuccess: 'Part of the data is imported successfully, please check the error list.',
    importFail: 'Import failed!',
    exportFail: 'Data export failed!',
    noMasterField: 'Can not create template,please define master field!',
    noCreatePermission: 'You have no permission to create a report!',
    deleteTemporary: 'Temporary report will be delete, continue?'
  },
  attach: {
    title: 'Attachment List',
    batchDownload: 'Batch Download',
    preview: 'Preview',
    prepare: 'Preparing documents, please wait ...',
    downloading: 'Downloading',
    processing: 'Processing, please wait ...',
    notSupport: 'Preview of files in this format is not supported at this time, please download and view them locally.',
    downloadAll: 'Download all pictures',
    donwloadFail: 'File download failed! ',
    infoFail: 'File information acquisition failed! ',
    imgFail: 'Picture acquisition failed! ',
    attachFail: 'Attachment acquisition failed!',
    notSet: 'Preview component is not set, unable to preview directly!'
  },
  listview: {
    pick: 'Pick',
    viewSelected: 'View Selected',
    selected: 'Selected',
    deleteAll: 'Delete All',
    isClearAll: 'Are you sure you want to clear all selected items?',
    oneRecord: 'Please select at least one record!',
    validRecord: 'Please select a valid record!'
  },
  location: {
    location: 'Location',
    setStart: 'Set as start point',
    setEnd: 'Set as end point',
    walking: 'Walking',
    driving: 'Driving',
    transit: 'Transit',
    routeName: 'Route Name',
    noTransit: 'No Transit Route',
    km: 'KM',
    m: 'M',
    minutes: 'minutes',
    hour: 'hour'
  },
  reset: {
    reset: 'Reset Password',
    back: 'Back to login',
    fill: 'Fill in account',
    auth: 'Authentication',
    setNew: 'Set new password',
    complete: 'Complete',
    email: 'E-mail:',
    code: 'Verification code',
    next: 'Next step',
    sendToEmail: 'The verification code has been sent to your email',
    emailCode: 'E-mail verification code',
    resetSuccess: 'Password reset succeeded',
    logNew: 'You can log in with the new password',
    codeRequired: 'verification code is required',
    codeError: 'Incorrect verification code',
    passRequired: 'Password is required',
    passAgain: 'Please enter the password again',
    twoPass: 'Two passwords are inconsistent',
    emailRequired: 'E-mail is required',
    correctEmail: 'Please input the correct email address'
  },
  register: {
    username: 'username',
    usernameRequired: 'username is required',
    codeRequired: 'Code is required',
    state: 'Verification code',
    register: 'Register',
    code: 'Code',
    basic: 'Basic',
    mailVaild: 'Activation',
    password: 'Password',
    registerSuccess: 'After successful registration, user can sign in Workfine.',
  },
  print: {
    preview: 'Print Preview'
  }
}
